export default __webpack_public_path__ + "static/img/3.98842a2.png";